import {useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {all_routes} from "../../../router/all_routes";
import {Log,DateTime,Str,Num} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Portal_Table} from "biz9-portal-app";
import {Review_Table} from "biz9-review";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import FormNoData from '../../../formNoData';
/* -- biz9 import end -- */
const Dashboard_Admin_Review = () => {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState("Reviews");
    const [reviews,setReviews] = useState([]);
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data() {
        /*
        let search = Data_Logic.get_search(Review_Table.REVIEW,{});
         let option = {get_join:true,field_keys:[{foreign_table:Portal_Table.PRODUCT,foreign_field:'id',item_field:'parent_id',title:'product',make_flat:true}],get_user:true,make_user_flat:true};
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setReviews(data.reviews);
        Toast_Message.dismiss();
        */
    };
    async function btn_delete(id: any) {
        if (window.confirm('Are you sure?')) {
             //Toast_Message.loading(Message.DELETING);
            //let [response,data] = await Portal_Remote_Data.delete(App.get_url(Data.Review_Table.REVIEW,id);
            //Toast_Message.success(response.message);
        }
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            {/*User Reviews */}
            <div className="col-xl-12 col-lg-12">
            <div className="user-review">
            <ul className="review-lists">
            {reviews.length<=0 && <FormNoData/>}
            {reviews.map((item) => (
                        <li>
                        <div className="review-wrap">
                        <div>
                        <div className="review-user-info">
                        <div className="review-img">
                        <Link target='_blank' to={"/app/"+item.product_title_url}>
                        <ImageWithBasePath
                        src={Image.get_url(item.product_image_filename,Image_Format.SQUARE_THUMB)}
                        alt=""
                        />
                        </Link>
                        </div>
                        <div className="reviewer-info">
                        <div className="reviewer-loc">
                        <h6>
                        <Link  target='_blank' to={"/app/"+item.product_title_url}>{item.product_title} </Link> {" - "}
                        <Link  target='_blank' to={all_routes.dashboard_admin_user_detail +"?id="+item.user_id}>{item.user_title} </Link>
                        </h6>
                        </div>
                        <div className="reviewer-rating">
                        <div className="star-rate">
                        <span className="ratings">
                        {Array.from({ length: parseInt(item.rating) }).map((_, index) => (
                                    <i className="fa-solid fa-star filled" />
                                    ))}
            </span>
                <span className="rating-count">{Num.get_decimal(item.rating)}</span>
                </div>
                <p>{DateTime.get_pretty(item.date_create)}</p>
                </div>
                </div>
                </div>
                <div className="review-content">
                <h6>
                {item.title}
            </h6>
                <p>
                {item.comment}
            </p>
                </div>
                </div>
                <div className="table-action">
                <Link to="#">
                <FeatherIcon icon="trash" onClick={(e) => { {btn_delete(item.id)} }} />
                </Link>
                </div>
                </div>
                </li>
                ))}
    </ul>
        </div>
        </div>
        {/* /User Reviews */}
    </div>
        </div>
        {/* /Page Content */}
    </>
        );
};
export default Dashboard_Admin_Review;
